import { storyblokEditable } from "@storyblok/react";
import SimpleTableRow from "./SimpleTableRow";

const SimpleTable = ({ blok }) => {
  const rows = Array.isArray(blok?.rows) ? blok.rows : [];

  return (
    <section {...storyblokEditable(blok)} className="w-full py-8">
      <div className="w-full overflow-x-auto">
        <table className="w-full min-w-[1100px] border-collapse border border-[#666] font-['Roboto']">
          <thead>
            <tr className="bg-[#E9E9E9]">
              <th className="border border-[#666] px-4 py-3 text-center text-[18px] md:text-[22px] font-semibold text-black align-middle">
                {blok.column_1_header}
              </th>
              <th className="border border-[#666] px-4 py-3 text-center text-[18px] md:text-[22px] font-semibold text-black align-middle">
                {blok.column_2_header}
              </th>
              <th className="border border-[#666] px-4 py-3 text-center text-[18px] md:text-[22px] font-semibold text-black align-middle">
                {blok.column_3_header}
              </th>
              <th className="border border-[#666] px-4 py-3 text-center text-[18px] md:text-[22px] font-semibold text-black align-middle">
                {blok.column_4_header}
              </th>
            </tr>
          </thead>

          <tbody>
            {rows.map((rowBlok) => (
              <SimpleTableRow blok={rowBlok} key={rowBlok._uid} />
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default SimpleTable;